module.exports = __webpack_public_path__ + "frontStatic/img/star-fill.5264a165.png";